import {Directive} from '@angular/core';

@Directive({selector: 'time'})
export class TimeDirective {
}
